import {CreateCoverNote, Identity, InsurerId, SortBy, UpdateDocument, VoidDocument} from '../../Config/dataModel';
import {authRequest} from './request';

const allCoverNotes = (data: SortBy) => {
    return authRequest({
        url: '/coverNote/getCoverNote',
        method: 'PUT',
        data
    });
};

const allArchived = (data: SortBy) => {
    return authRequest({
        url: '/coverNote/getArchived',
        method: 'PUT',
        data
    });
};

const coverNote = (ref: string, data: InsurerId) => {
    return authRequest({
        url: `/coverNote/ref/${ref}`,
        method: 'PUT',
        data
    });
};

const coverNoteCount = (data: InsurerId) => {
    return authRequest({
        url: '/coverNote/getCoverNoteCount',
        method: 'PUT',
        data
    });
};

const archivedCount = (data: InsurerId) => {
    return authRequest({
        url: '/coverNote/getArchivedCount',
        method: 'PUT',
        data
    });
};

const subAgentApplyCN = (data: CreateCoverNote) => {
    return authRequest({
        url: '/coverNote/subagent/apply',
        method: 'PUT',
        data
    });
};

const insurerApplyCN = (data: CreateCoverNote) => {
    return authRequest({
        url: '/coverNote/insurer/applyCoverNote',
        method: 'PUT',
        data
    });
};

const insurerConfirmCN = (ref: string, data: Identity) => {
    return authRequest({
        url: `/coverNote/insurer/confirmCoverNote/${ref}`,
        method: 'PUT',
        data
    });
};

const updateCoverNote = (ref: string, data: UpdateDocument) => {
    return authRequest({
        url: `/coverNote/updateCoverNote/${ref}`,
        method: 'PUT',
        data
    });
};

const voidCoverNote = (ref: string, data: VoidDocument) => {
    return authRequest({
        url: `/coverNote/voidCoverNote/${ref}`,
        method: 'PUT',
        data
    });
};

const coverNoteHistory = (ref: string, data: InsurerId) => {
    return authRequest({
        url: `/coverNote/ref/${ref}/history`,
        method: 'PUT',
        data
    });
};

const coverNoteAPI = {
    allCoverNotes,
    allArchived,
    coverNote,
    coverNoteCount,
    archivedCount,
    subAgentApplyCN,
    insurerApplyCN,
    insurerConfirmCN,
    updateCoverNote,
    voidCoverNote,
    coverNoteHistory
};

export default coverNoteAPI



// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/coverNoteAPI.ts